

















































import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import { NavigationDataStore } from '@store/modules/navigation';
import { SportOfferUIStore } from '@store/modules/ui/sportOffer/sports/sportsIndex';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    ref,
    onMounted,
} from '@vue/composition-api';
import Sport from '@core/models/struct/Sport';
import { useSports } from '@src/app/shared/modules/sportOffer/composition/useSports';
import SdsMobileHeader from '@src/app/mobile/navbar/SdsMobileHeader.vue';
import { ModalStore } from '@store/modules/ui/shared/modal/modalIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

export default defineComponent({
    setup() {
        const sportOfferUiStore = useVuexStore<SportOfferUIStore>('ui/sportOffer/sports');
        const sportOfferDataStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
        const navigationDataStore = useVuexStore<NavigationDataStore>('navigation');
        const modalStore = useVuexStore<ModalStore>('ui/modal');
        const isHeaderContracted = ref(false);

        onMounted(() => {
            window.addEventListener('scroll', () => {
                isHeaderContracted.value = document.documentElement.scrollTop > 50;
            });
        });

        const currentSportId = sportOfferUiStore.getter('currentSportId');

        const currentSportName = computed(() => {
            return currentSportId.value
                ? sportOfferDataStore.getter('sports').value[currentSportId.value]?.name ?? null
                : null;
        });

        const isOnSportLivePage = navigationDataStore.getter('isOnSportLivePage');
        const showSportFilter = computed(() => currentSportName.value !== null && !isOnSportLivePage.value);
        const iconSize = computed(() => isHeaderContracted.value ? 'lg' : 'xl');

        const {
            sports,
            resolveSportLink,
        } = useSports();

        const sportItems = computed(() => sports.value.map((sport) => ({
            ...sport,
            href: resolveSportLink(sport.id),
        })));

        function openSportFilter() {
            modalStore.action('pushModal')({
                code: modalCodes.sportSelectDrawer,
                data: {
                    items: sportItems.value,
                    setSport: setSportFilter,
                    selectedItem: currentSportId.value,
                },
            });
        }

        const setSelectedTreeItem = sportOfferUiStore.action('setSelectedTreeItem');
        function setSportFilter(sport: Sport) {
            setSelectedTreeItem([sport]);
        }

        return {
            currentSportName,
            showSportFilter,
            isOnSportLivePage,
            iconSize,
            openSportFilter,
        };
    },
    components: {
        SdsMobileHeader,
        SdsIcon,
    },
});
